import React, {FunctionComponent, PropsWithChildren} from "react";
import {Form} from "formik";
import {UserDto} from "../../../utils/types/user";
import {Text, styled, FlexRow, theme} from "@reside/ui";

import {AdminLayout} from "../../../atoms/admin-layout";
import {AdminPageTitle} from "../../../atoms/admin-layout/AdminPageTitle";
import {Spinner} from "../../../atoms/spinner";
import {SubmitButtons} from "./submit-buttons";
import {SidebarMenu} from "./SidebarMenu";
import {SSOBadge} from "../../../atoms/list-table/SSOBadge";

export const PageAdminProfileLayout: FunctionComponent<
  PropsWithChildren<{
    user: UserDto;
    isLoading?: boolean;
  }>
> = ({user, children, isLoading}) => (
  <AdminLayout>
    {!user && !!isLoading ? (
      <Spinner />
    ) : user ? (
      children
    ) : (
      <NoUserFound>
        <Text>No user found with these parameters...</Text>
      </NoUserFound>
    )}
  </AdminLayout>
);

export const ProfileFormLayout: FunctionComponent<
  PropsWithChildren<{user: UserDto}>
> = ({user, children}) => (
  <Form>
    <Header>
      <div style={{display: "flex", alignItems: "center", gap: theme.space[4]}}>
        <AdminPageTitle>
          {" "}
          {`${user.firstName} ${user.lastName}`}{" "}
        </AdminPageTitle>
        {user.isSsoUser && <SSOBadge label="SSO user" />}
      </div>
      <SubmitButtons />
    </Header>
    <FlexRow>
      <SidebarMenu user={user} />
      <FormWrapper>{children}</FormWrapper>
    </FlexRow>
  </Form>
);

const Header = styled(FlexRow)`
  margin-bottom: 15px;
  align-items: center;
`;

const FormWrapper = styled.div`
  flex: 3;
`;

const NoUserFound = styled.div`
  margin: 20px;
`;
